import { safeStorage } from '../helpers/safeStorage';

function pageCheckout() {
  const initializedAttribute = "data-checkout-products-initialized";

  function updateAddToCartButtonHref($button, productId) {
    $button.attr("data-product-id", productId);
    $button.removeAttr("data-purchase-intent-key data-purchase-intent-key-product");

    if ($button.attr("data-purchase-intent-required") === "1") {
      return;
    }

    const href = $button.attr("href");

    if (!href) {
      return;
    }

    try {
      const url = new URL(href, window.location.origin);

      if (url.searchParams.has("add-to-cart")) {
        url.searchParams.set("add-to-cart", productId);
      }

      if (url.searchParams.has("product_id")) {
        url.searchParams.set("product_id", productId);
      }

      $button.attr("href", url.toString());
    } catch (error) {
      let newHref = href.replace(/add-to-cart=\d+/, `add-to-cart=${productId}`);
      newHref = newHref.replace(/product_id=\d+/, `product_id=${productId}`);

      $button.attr("href", newHref);
    }
  }

  function resolveCheckoutButtons($productsWrapper) {
    let $buttons = $productsWrapper.find(".btn-addtocart");

    if ($buttons.length) {
      return $buttons;
    }

    const $checkoutScope = $productsWrapper
      .closest(
        ".woocommerce-MyAccount-content, #offers, .ps-offer-section, main",
      )
      .first();

    if ($checkoutScope.length) {
      $buttons = $checkoutScope.find(".btn-addtocart");
    }

    // Some account templates produce invalid list-adjacent markup that the
    // browser reparents outside .b-products. Only fall back to page-wide CTAs
    // when this is the sole product selector, so independent offers cannot
    // overwrite each other.
    if (!$buttons.length && $(".b-products").length === 1) {
      $buttons = $(".btn-addtocart");
    }

    return $buttons;
  }

  function resolveProductsWrapper($product) {
    const $catalog = $product.closest(".b-products, .woocommerce").first();
    if ($catalog.length) {
      return $catalog;
    }

    return $product
      .closest(
        ".woocommerce-MyAccount-content, #offers, .ps-offer-section, main",
      )
      .first();
  }

  function selectProduct($product, $productsWrapper) {
    if (!$product.length) {
      return;
    }

    $productsWrapper.find(".products .product").removeClass("is-selected");
    $product.addClass("is-selected");
    $product.find(".growtype-credit-product-input").prop("checked", true);

    let words = $product.attr("class").split(/\s+/);
    let productId = words.filter((word) => word.startsWith("post-"))[0];

    if (!productId) {
      return;
    }

    productId = productId.replace("post-", "");

    resolveCheckoutButtons($productsWrapper).each(function () {
      updateAddToCartButtonHref($(this), productId);
    });

    // Update subscription terms text based on selected plan
    const termsEl = document.getElementById("subscription-terms-text");
    if (termsEl) {
      const plansData = JSON.parse(termsEl.dataset.subscriptionPlans || "{}");
      const planData = plansData[productId];
      if (planData) {
        if (planData.has_signup_fee) {
          termsEl.textContent = planData.terms_text;
          termsEl.style.display = "";
        } else {
          termsEl.style.display = "none";
        }
      }
    }
  }

  function initializeProductsWrapper($productsWrapper) {
    if (
      !$productsWrapper.length ||
      $productsWrapper.attr(initializedAttribute) === "1"
    ) {
      return;
    }

    $productsWrapper.attr(initializedAttribute, "1");
    const defaultProductId = $productsWrapper.attr("data-default-product-id");
    let $initialProduct = $productsWrapper
      .find(".products .product.is-selected")
      .first();

    if (!$initialProduct.length && defaultProductId) {
      $initialProduct = $productsWrapper.find(
        `.products .product.post-${defaultProductId}`,
      );
    }

    if (!$initialProduct.length) {
      $initialProduct = $productsWrapper.find(".products .featured").first();
    }

    if (!$initialProduct.length) {
      $initialProduct = $productsWrapper.find(".products .product").first();
    }

    selectProduct($initialProduct, $productsWrapper);
  }

  function initializeProductsWithin(root) {
    const $root = $(root);
    const $wrappers = $root.is(".b-products")
      ? $root.add($root.find(".b-products"))
      : $root.find(".b-products");

    $wrappers.each(function () {
      initializeProductsWrapper($(this));
    });
  }

  if (document.readyState === "loading") {
    $(function () {
      initializeProductsWithin(document);
    });
  } else {
    initializeProductsWithin(document);
  }

  $(document)
    .off("click.pageCheckoutProduct", ".products .product")
    .on("click.pageCheckoutProduct", ".products .product", function () {
      const $product = $(this);
      selectProduct($product, resolveProductsWrapper($product));
    });

  // Some product-card scripts stop click bubbling after updating their own
  // visual state. Reconcile the checkout CTAs in the capture phase as well.
  if (!document.documentElement.dataset.checkoutProductCaptureBound) {
    document.documentElement.dataset.checkoutProductCaptureBound = "1";
    document.addEventListener(
      "click",
      (event) => {
        const product = event.target.closest(".products .product");
        if (!product) {
          return;
        }

        const $product = $(product);
        selectProduct($product, resolveProductsWrapper($product));
      },
      true,
    );
  }

  $(document)
    .off("change.pageCheckoutProduct", ".growtype-credit-product-input")
    .on(
      "change.pageCheckoutProduct",
      ".growtype-credit-product-input",
      function () {
        selectProduct(
          $(this).closest(".product"),
          resolveProductsWrapper($(this).closest(".product")),
        );
      },
    );

  jQuery("body").on("applied_coupon", function (event, coupon, data) {
    window.location.reload();
  });

  /**
   * Last chance modal exit intent
   */
  let exitIntentShown = safeStorage.session.get("growtype_last_chance_shown");
  $(document).on("mouseleave", function (e) {
    if (e.clientY < 0 && !exitIntentShown) {
      let modalElement = $("#growtypeChatLastChanceModal");

      if (modalElement.length > 0) {
        // Don't show if another modal is already open
        let otherModalOpen =
          $(".modal.show").not("#growtypeChatLastChanceModal").length > 0 ||
          $("#gwcPaypalHostedFieldsModal").is(":visible");

        if (otherModalOpen) {
          return;
        }

        window.growtypeModal?.show(modalElement[0]);
        exitIntentShown = true;
        safeStorage.session.set("growtype_last_chance_shown", "true");
      }
    }
  });
}

export { pageCheckout };
